'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _LinkContainer = require('react-router-bootstrap/lib/LinkContainer');

var _LinkContainer2 = _interopRequireDefault(_LinkContainer);

var _NavItem = require('react-bootstrap/lib/NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

var _propTypes3 = require('utils/prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./Tab.scss');

var Tab = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Tab, _Component);

  function Tab() {
    (0, _classCallCheck3.default)(this, Tab);
    return (0, _possibleConstructorReturn3.default)(this, (Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).apply(this, arguments));
  }

  (0, _createClass3.default)(Tab, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          className = _props.className,
          to = _props.to,
          title = _props.title,
          onClick = _props.onClick;


      return _react2.default.createElement(
        _LinkContainer2.default,
        { to: to },
        _react2.default.createElement(
          _NavItem2.default,
          {
            className: (0, _bind2.default)(styles.tab, className, (0, _defineProperty3.default)({}, styles.active, active)),
            onClick: onClick
          },
          title
        )
      );
    }
  }]);
  return Tab;
}(_react.Component), _class.propTypes = {
  active: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  title: _propTypes3.node,
  to: _propTypes2.default.string
}, _class.defaultProps = {
  active: false,
  onClick: _noop3.default
}, _temp);
exports.default = Tab;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Tabs/Tab/Tab.js
// module id = 853
// module chunks = 1